import { connect } from 'react-redux';
import PropProvider from '../PropProvider';
import EntityReplicateDialog from '../components/entity/ReplicateDialog';
import { defaultMapDispatchToProps } from '../utils/ConnectDefaults';

export default connect(
  (state, ownProps) => PropProvider(state).EntityReplicateDialog(ownProps),
  defaultMapDispatchToProps
)(EntityReplicateDialog);
